<template>
	<section>
		<!-- 左边开始 -->
		<div class="left" :class="{'left-cashier': isCashier}" v-loading="loadingAdd">
			<div class="heard" id="goodsList">
				<div class="input">
					<el-input style="width:80%" type="text" size="medium" border-radius="0" v-model="keywords" @keyup.enter.native="queryProject" placeholder="扫码条形码或输入关键字" >
						<span class="icon" slot="suffix"><i class="el-icon-camera-solid"></i></span>
					</el-input>
				</div>
				<el-button type="primary" size="medium" @click="queryProject">{{queryText}}</el-button>
				<div class="tabs">
					<el-tabs type="border-card" v-model="tabSelect" >
						<el-tab-pane name="goods" label="商品" v-if="isShowGoods">
							<span v-for="(items,index) in goodsCategoryList" :key='index'>
								<el-button class="pa_btn" size="small" type="FFF" :class="index == goodsIndex?'on':'white'" @click="getGoodsList(index,items.category_id,items.childNode)">
									{{items.category_name}}
								</el-button>
							</span>
							<div style="margin-top:5px;">
								<span v-for="(secondItem,secondIndex) in secondCategoryList" :key='secondIndex'>
									<el-button class="pa_btn" size="small" type="FFF" :class="secondIndex == secondGoodsIndex ? 'on': 'white'" @click="secondGoodsList(secondIndex,secondItem.category_id)">
									 {{ secondItem.category_name }}
									</el-button>
								</span>
							</div>
						</el-tab-pane>
						<el-tab-pane name="service" label="服务">
							<span v-for="(items,index) in serviceCategoryList" :key='index'>
								<el-button class="pa_btn" size="small" type="FFF" :class="index == serviceIndex?'on':'white'" @click="getServiceList(index,items.category_id)">
									{{items.category_name}}
								</el-button>
							</span>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>

			<!-- 商品列表 -->
			<div class="content" v-if="tabSelect ==='goods'" :style="goodslistheight" v-infinite-scroll="load" :infinite-scroll-disabled='goodsDisabled'>
				<el-row>
					<el-col :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 12, offset: 0}" :lg="{span: 6, offset: 0}"
					 :xl="{span: 4, offset: 0}" v-for="(item,index) in goodsList" :key="index" :offset="index > 0 ? 2 : 0">
						<span class="goods_list_box" :class="{selStyle: item.appointment == '1'}" @click="selectGoodsItem(item)">
							<div class="title">{{item.goods_name}}</div>
							<div class="price">售价：
								<span v-if="item.goods_price_min == item.goods_price_max">¥{{item.goods_price_max}}</span>
								<span v-else>¥{{item.goods_price_min}}~{{item.goods_price_max}}</span>
							</div>
						</span>
					</el-col>
				</el-row>
				<div align="center" style="color:#FF700B; margin-top: 30px">
					<p v-if="loadingData" class="loadMust">加载中...</p>
					<p v-else-if="noGoodsMore" class="loadMust">没有更多了</p>
				</div>
			</div>
			<!-- 服务列表 -->
			<div class="content" v-else-if="tabSelect ==='service'" :style="goodslistheight" v-infinite-scroll="load" :infinite-scroll-disabled='serviceDisabled'>
				<el-row>
					<el-col :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 12, offset: 0}" :lg="{span: 6, offset: 0}"
					 :xl="{span: 4, offset: 0}" v-for="(item,index) in serviceList" :key="index" :offset="index > 0 ? 2 : 0">
						<span class="goods_list_box" :class="{selStyle: item.appointment == '1'}" @click="selectGoodsItem(item)">
							<div class="title">{{item.service_name}}</div>
							<div class="price">售价：
								<span v-if="item.service_price_min == item.service_price_max">¥{{item.service_price_max}}</span>
								<span v-else>¥{{item.service_price_min}}~{{item.service_price_max}}</span>
							</div>
						</span>
					</el-col>
				</el-row>
				<div align="center" style="color:#FF700B">
					<p v-if="loadingData" class="loadMust">加载中...</p>
					<p v-else-if="noServiceMore" class="loadMust">没有更多了</p>
				</div>
			</div>
		</div>
		<!-- 左边结束 -->


		<el-dialog title="选择规格" width="30%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancelSelected">
			<div class="showCon" style="margin-left:20px;">
				<dl class="pa_select_sku_box" style="margin-bottom:10px;" v-for="(obj, key, sub) in selectItem.skuList" :key="sub">
					<dd class="item">
						<div style="margin-left:5px;margin-bottom:5px;">{{key}}：</div>
						<el-radio-group @change="radioSkuTap(key, obj.arr)" size="small" v-model="obj.arr">
							<el-radio :label="arr" v-for="(arr, aindex) in obj" :key="aindex" border>{{arr}}</el-radio>
						</el-radio-group>
					</dd>
				</dl>
				<div class="flex" style="padding-top:10px;border-top:solid 1px #e5e5e5;">
					<div style="width:50%;color:#FF700B;font-weight:16px;font-weight:bold;">
						￥{{selectedSkuPrice}}
					</div>
					<div v-if="selectedSkuError">{{selectedSkuError}}</div>

				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelSelected">取 消</el-button>
				<el-button type="FF7" @click="submitSelected" :disabled="!btnAddFlag">保 存</el-button>
			</div>
			<!-- new 2 end -->
		</el-dialog>
	</section>
</template>

<script>
	import { checkBarCode, calculate } from '@/api/common'
	import { isEmpty } from '@/common/js/util'
	import { objectEqual, objectAttributeCountEqual } from '@/common/js/validator.js'
	import { resetInsertData } from '@/common/js/util'
	export default {
        name: 'select-product',
		props:{
			isCashier:{
				type: Boolean,
				default: false
			},
			appointmentId: {
				type: [Number, String] ,
				default: 0
			},
			appointmentType: {
				type: String,
				default: 'goods'
			},
			userId: {
				type: [Number, String] ,
				default: 0
			},
			selProduct: {
				type: [Array, Object],
				default: {
					goods_id: new Set(),
					goods_sku_id: new Set(),
					service_id: new Set(),
					service_sku_id: new Set(),
				}
			}
		},
		data() {
			return {
				goodslistheight: {
					top: '145px',
				},
				keywords: '',
				goods_id: 0,
				goods_sku_id: 0,
				service_id: 0,
				service_sku_id: 0,
				cart_type: 'goods', //默认传商品类型
				appointment_type: 'goods',
				default_quantity: 1,

				loadingData: false,
				loadingAdd: false,

				tabSelect: 'goods', //默认商品
				goodsCategoryList: [], //商品分类数据
				serviceCategoryList: [], //服务分类数据

				goodsIndex: '0', //商品分类选中索引
				serviceIndex: '0', //服务分类选中索引
				goodsList: [], //商品数据
				serviceList: [], //服务数据

				goods_cateogry_id: '0', //商品分类ID
				service_category_id: '0', //服务分类ID
				limit: 50,

				selectItem: {}, //选中的商品、服务对象
				skuSelectedList: [], //选中的SKU
				btnAddFlag: false,

				selectedSkuPrice: '0',
				selectedSkuError: '',

				user_id: '0',
				secondCategoryList: [],
				secondGoodsIndex: '0',
				goods_second_category: '0',

				page: 1,
				count: 0,
				servicePage: 1,
				serviceCount: 0,


				appointment_id: 0,

				isQuickAdd:true,
				// queryText:'查询',

                dialogVisible: false,
			}
		},
		computed: {
			queryText(){
				return checkBarCode(this.keywords) ? '添加': '查询';
			},
			noGoodsMore() {
				if (this.count == 0) {
					return true;
				}
				return this.count <= this.goodsList.length;
			},
			noServiceMore() {
				if (this.serviceCount == 0) {
					return true;
				}
				return this.serviceCount <= this.serviceList.length;
			},
			goodsDisabled() {
				return this.loadingAdd || this.noGoodsMore;
			},
			serviceDisabled() {
				return this.loadingAdd || this.noServiceMore;
			},
			isShowGoods(){
				const val = this.isCashier || this.appointment_id > 0
				this.tabSelect = val ? 'goods' : 'service'
				return val
			},
		},
		// mounted() {
			
		// },
		watch: {
			screenWidth(val) {
				this.height = val
			},
			selProduct:{
				handler(val){
					this.goodsList.forEach((obj)=>{
						obj.appointment = val.goods_id.has(obj.goods_id) ? 1 : 0;
					})
					this.serviceList.forEach((obj)=>{
						obj.appointment = val.service_id.has(obj.service_id) ? 1 : 0
					})
				},
				immediate: true,
				deep: true,
			},
			appointmentType(val) {
				this.appointment_type = val === 'service_appointment' ? 'service' : val
			},
			appointmentId:{
			    handler(val){
					this.appointment_id = val
				},
				deep: true,
				immediate: true,
			},
			userId:{
				 handler(val){
					this.user_id = val
				},
				deep: true,
				immediate: true,
			}
		},
		
		created() {
			// this.appointment_id = this.appointmentId;
			this.cart_type 		= this.appointmentType;
			this.user_id 		= this.userId;
			// this.tabSelect =  this.isCashier || this.appointment_id > 0 ? 'goods': 'service'
			this.initData();
			// this.addItem();
		},

		methods: {
			initData(){
				const postDataList = [
					{
						x_method : 'com.get.goods.category.list_all'
					},
					{
						x_method : 'com.get.service.category.list'
					}
				];
				this.loadingAdd = true;
				this.$apis(postDataList).then(res_list => {
					for (let x in res_list) {
						let res = res_list[x]
						if (res.status == 10000) {
						
							switch (x){
								case 'com.get.goods.category.list_all':
								{
									for (let x in res.data.list) {
										if(res.data.list[x].childNode.length >0 ){
											res.data.list[x].childNode.unshift({ category_id: 0, category_name: '全部' })
										}
									}
									res.data.list.unshift({category_id: 0, category_name: '全部', childNode:[]}) 
									this.goodsCategoryList = res.data.list;
									this.goodsDataList();
									break;
								}
								case 'com.get.service.category.list':
								{
									res.data.list.unshift({category_id: 0, category_name: '全部', childNode: []}) 
									this.serviceCategoryList = res.data.list;
									this.serviceDataList();
									break;
								}
								default:
									break;
							}
						}else {
							this.$message.error(res.info);
						}
					}
				}).finally(()=>{
					this.loadingAdd = false
				});
			},
			// 初始化服务列表
			load() {
				if (this.tabSelect == 'goods') {
					if (this.goodsList.length < this.count) {
						this.loadingAdd = true;
						this.goodsDataList();
					}
				} else {
					if (this.serviceList.length < this.serviceCount) {
						this.loadingAdd = true;
						this.serviceDataList();
					}
				}
			},
			clearSelect() {
				// resetInsertData()
				this.selectItem = {};
				this.skuSelectedList = [];
				this.selectedSkuPrice = '0';
				this.goods_sku_id = '';
				this.goods_id = '';
				this.service_id = '';
				this.service_sku_id = '';
				this.selectedSkuError = '';
				this.btnAddFlag = false;
				this.cart_type = 'goods';
			},
			//取消SKUx选择
			cancelSelected() {
				this.clearSelect();
				this.dialogVisible = false;
			},
			//确定添加SKU到购物车
			submitSelected() {
				this.dialogVisible = false;
				this.addItem();
				this.clearSelect();
			},
			//规格选中事件
			radioSkuTap(key, value) {
				this.skuSelectedList[key] = value;
				//判断是否已经选择全属性了 
				if (!objectAttributeCountEqual(this.skuSelectedList, this.selectItem.skuList) || !['goods','service'].includes(this.cart_type)) {
                    return
				}
                const typeInfo = {
                    goods: {
                        sku_id: 'goods_sku_id',
                        specs: 'goods_specs',
                        price: 'goods_price',
                    },
                    service: {
                        sku_id: 'service_sku_id',
                        specs: 'service_desc',
                        price: 'service_price',
                    }
                };

                const sku_id = typeInfo[this.cart_type].sku_id;
                const specs = typeInfo[this.cart_type].specs;
                const price = typeInfo[this.cart_type].price;
                const matchedSku = this.selectItem.sku_list.find(skuRow => {
                    return objectEqual(this.skuSelectedList, JSON.parse(skuRow[specs]))
                });
                if (matchedSku) {
                    // 匹配到了对应的商品规格
                    if (this.selProduct[sku_id].has(matchedSku[sku_id])) {
                        // 该商品规格已被选中
                        this.btnAddFlag = false;
                        this.selectedSkuError = '当前规格已选';
                        return
                    } 
                    
                    if (matchedSku.goods_inventory === '0') {
                        // 该商品规格库存不足
                        this.btnAddFlag = false;
                        this.selectedSkuError = '暂无库存';
                        return
                    }

                    // 该商品规格可选
                    this.selectedSkuError = '';
                    this.selectedSkuPrice = matchedSku[price];
                    this[sku_id] = matchedSku[sku_id];
                    this.btnAddFlag = true;
                }

			},
			//选中列表中的商品
			selectGoodsItem(item) {
				//切换新商品则重置掉对应数据
				this.selectItem 		= item;
				this.skuSelectedList 	= [];
				this.selectedSkuPrice 	= '0';
				this.selectedSkuError 	= '';
				this.appointment_id 	= '';
				this.btnAddFlag 		= false;
				this.isQuickAdd 		= false

                if (!isEmpty(item.goods_id)) {
                   	this.cart_type 			= 'goods';
                    this.goods_sku_id 		= '';
                    this.goods_id 			= item.goods_id;   
					this.project_name = item.goods_name;
					this.project_price = item.goods_retail_price;  
                }else if (!isEmpty(item.service_id)) {
                    
                    this.cart_type 			= 'service';
                    this.service_sku_id     = '';
                    this.service_id         = item.service_id;
					this.project_name = item.service_name;
					this.project_price = item.order_amount;
                }else {
                    this.messages('稍后重试', 'warning');
                    return;
                }
			

                Object.keys(this.selectItem.skuList).forEach(sku => delete this.selectItem.skuList[sku].arr);

				if (item.appointment == '1') {
					this.messages('当前规格已选', 'warning');
					return
				}
				if (item.sku_list.length > 0) {
					this.dialogVisible = true;
				} else {
                    this.$confirm('是否确定添加?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						item.appointment = '1'
						this.addItem();
					}).catch(()=>{});
				}
			},
			//点击商品分类获取商品数据
			getGoodsList(goods_index, goods_category_id, secondItemList) {
				this.goodsList = [];
				this.goodsIndex = goods_index;
				this.goods_category_id = goods_category_id;
				this.secondCategoryList = secondItemList;
				
				this.secondGoodsIndex = '0';
				this.goods_second_category = '0';
				this.count = 0;
				this.page = 1;

				const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
			
				const option = {
					childList: true, // 子节点的变动（新增、删除或者更改）
					attributes: true, // 属性的变动
					characterData: true, // 节点内容或节点文本的变动
					subtree: true, // 是否将观察器应用于该节点的所有后代节点
					attributeFilter: ['style'], // 观察特定属性
					attributeOldValue: true, // 观察 attributes 变动时，是否需要记录变动前的属性值
					characterDataOldValue: true // 观察 characterData 变动，是否需要记录变动前的值
				}
				const that = this;
				const observer = new MutationObserver(function(mutations) {
					const height = document.getElementById('goodsList').offsetHeight;
					that.goodslistheight.top = height + 'px';
				});
				const height = document.getElementById('goodsList')
				observer.observe(height, option);

				this.goodsDataList();
			},
			//二级分类点击事件
			secondGoodsList(secondGoods_index, second_category_id) {
				this.goodsList = [];
				this.secondGoodsIndex = secondGoods_index;
				this.goods_second_category = second_category_id;

				this.page = 1;
				this.count = 0;

				this.goodsDataList();
			},
			//点击服务分类获取服务数据
			getServiceList(service_index, service_category_id) {
				this.serviceList = [];
				this.serviceIndex = service_index;
				this.service_category_id = service_category_id;

				this.servicePage = 1;
				this.serviceCount = 0;

				this.serviceDataList();
			},
			//获取商品数据
			goodsDataList() {
				this.loadingData = true;
				// let postData = {
				// 	keywords			: this.keywords,
				// 	category_parent_id	: this.goods_category_id,
				// 	category_id			: this.goods_second_category,
				// 	limit				: this.pageLimit,
				// 	page				: this.page,
				// };	
				// if (this.cart_type === 'service_appointment') {
				// 	postData = Object.assign({}, postData, { service_appointment_id: this.appointment_id })
				// }else if (this.cart_type === 'foster'){
				// 	postData = Object.assign({}, postData, { foster_appointment_id: this.appointment_id })
				// }
				const { appointment_id, appointment_type, goods_category_id: category_parent_id, page, limit, keywords, goods_second_category: category_id  } = this
				const postData = {
					method: 'com.get.goods.goods.list',
					data: {
						keywords,
						limit,
						page,
						category_parent_id,
						category_id,
						...(appointment_id > 0 ? { [`${appointment_type}_appointment_id`]: appointment_id } : {})
					}
				}
				this.$ajax(postData).then(res => {
					if (res.status === 10000) {
						this.count = res.data.count
						this.page++
						let obj = {};
						const result = res.data.list.reduce((prev, curr) => {
							if (!obj[curr.goods_id]) {
								const sku_list = JSON.parse(curr.goods_sku_type);
								prev.push({
									...curr,
									skuList: sku_list
								});
								obj[curr.goods_id] = true;
							}
							return prev;
						}, []);
						this.goodsList = res.data.page == 1 ? result : this.goodsList.concat(result);
					}
				}).finally(()=>{
					this.loadingAdd = false;
					this.loadingData = false;
				})
			},
			//获取服务数据
			serviceDataList() {
				this.loadingData = true;
				const { appointment_id, appointment_type, keywords, limit, servicePage: page, service_category_id: category_id } = this
				const postData = {
					method: 'com.get.service.service.list',
					data: {
						keywords,
						limit,
						page,
						category_id,
						...(appointment_id > 0 ? { [`${appointment_type}_appointment_id`]: appointment_id } : {})
					}
				}
				this.$ajax(postData).then(res => {
					if (res.status === 10000) {
						this.serviceCount = res.data.count
						this.servicePage++

						const result = [];
						let tempList = res.data.list;
						for (var i = 0; i < tempList.length; i++) {
							tempList[i].skuList = JSON.parse(tempList[i].service_sku_type);
							result.push(tempList[i]);
						}

						if (res.data.page == 1) {
							this.serviceList = result;
						} else {
							this.serviceList = this.serviceList.concat(result);
						}
					}
				}).finally(()=>{
					this.loadingData = false;
					this.loadingAdd = false;
				})
			},
			queryProject(){
				this.isQuickAdd = true
				if(checkBarCode(this.keywords)){
					if (this.isCashier) {
						this.addItem();
					}else {
						this.addBarcodeItem();
					}
				}else{
					this.goodsList = []
					this.count = 0
					this.page = 1
					this.goodsDataList()
					this.serviceList = []
					this.servicePage = 1
					this.serviceCount= 0
					this.serviceDataList()
				}
			},
			addBarcodeItem() {
				const postData = {
					x_version	: '2.5',
					method		: 'com.get.merge.barcode.goods_and_service.item',
					data: {
						barcode			: this.isQuickAdd ? this.keywords : '',
						user_id			: this.user_id,
						appointment_id	: this.appointment_id,
						appointment_type: this.appointment_type,
					}
				}
				this.$ajax(postData).then(res => {
					if (res.status == 10000) {
						if (res.data.barcode_type == 'goods') {
							this.goods_id = res.data.id;
							this.goods_sku_id = res.data.sku_id;
							this.project_name = res.data.item.goods_name;
							this.project_price = res.data.item.goods_retail_price;
						} else {
							this.service_id = res.data.id;
							this.service_sku_id = res.data.sku_id;
							this.project_name = res.data.item.service_name;
							this.project_price = res.data.item.order_amount;
						}
						this.addItem();
					} else {
						this.$message.error(res.info);
					}
				})
			},
			//通过输入条形码进行添加商品或服务
			addItem() {
				let postData = {
					user_id			: this.user_id,
					goods_code		: this.isQuickAdd ? this.keywords:'',
					goods_id		: this.goods_id,
					goods_sku_id	: this.goods_sku_id,
					service_id		: this.service_id,
					service_sku_id	: this.service_sku_id,
					cart_type		: this.cart_type,
					quantity		: this.default_quantity,
					appointment_id	: this.appointment_id,
					...((isEmpty(this.user_id) || isEmpty(this.appointment_id)) ? { use_member_price: 1 } : {})
				}
				
				let project = {
					project_name	: this.selectItem[`${this.cart_type}_name`],
					project_type	: this.cart_type, //2-服务 1-商品
					project_price	: this.project_price,
					temp_total_amount: this.project_price,
					skuList			: this.skuSelectedList, //SKU数值
				}
					

				if (isEmpty(postData.user_id)  || isEmpty(postData.appointment_id)) {
					postData.use_member_price = '1'
				}
				this.$emit('addItem', postData, project);
				
				this.clearParams();
			},
			//清除新增的参数数据
			clearParams() {
				this.keywords = '';
				// this.queryText = '查询'
				this.goods_id = '';
				this.goods_sku_id = '';
				this.service_id = '';
				this.service_sku_id = '';
			},
		}
	}
</script>

<style>
	/* *.el-dialog__headerbtn {
		font-size: 24px;
		font-weight: bold;
	} */

	
	.left .pa_btn {
		font-size: 12px;
		padding: 0 5px;
		height: 30px;
		min-width: 60px;
	}

	.left .pa_btn.on {
		background: #FF700B;
		color: #fff;
	}

	.left {
		position: fixed;
		bottom: 0;
		right: 447px;
		top: 50px;
		left: 0px;
		background-color: #FFFFFF;
		border-right: 0.5px solid #f8f8f8;
		z-index: 10;
	}
	.left-cashier {
		top: 70px;
		left: 150px;
	}
	.left .heard {
		margin: 5px;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		z-index: 30;
	}
	.left .heard .input {
		margin: 5px;
		display: inline;
	}
	.left .heard .input .icon {
		display: inline-block;
		line-height: 36px;
		font-size: 18px;
	}

	.left .heard .tabs {
		margin: 5px;
	}

	/* .left .heard .tabs .el-tabs__content{
	height: 70px;
    padding: 5px;
} */
	.left .heard .input .el-input__inner {
		border-radius: 0px;
	}

	.left .content {
		position: absolute;
		top: 160px;
		left: 0;
		right: 0;
		bottom: 0;
		margin: 10px 10px 0 10px;
		overflow: auto;
		border-left: 0px;
	}

	.left .content_2 {
		position: absolute;
		top: 140px;
		left: 0;
		right: 0;
		bottom: 0;
		margin: 10px;
		overflow: auto;
	}

	.goods_list_box {
		/*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		margin: 5px 2px;
		cursor: pointer;
		padding: 5px;
		height: 100px;
		display: inline-block;
		width: 93%;
	}

	.goods_list_box .title {
		font-size: 14px;
		height: 70px;
		font-weight:bold;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
	}

	.goods_list_box .price {
		font-size: 12px;
		color: #FF700B;
		margin-top: 5px;
		height: 30px;
		line-height: 30px;
	}

	.selStyle{color:#FF700B;border-color:#FF700B;}
</style>



// WEBPACK FOOTER //
// selectProduct.vue?6d18f94a